import type { AllRouteEndpoints } from "../routeTypes";
export const engagementLandingPageTemplateIdCacheKeys: AllRouteEndpoints[] = [
  "/engagement/landing_page_templates_data",
  "/engagement/landing_page_templates_data/:id",
];
